'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (Overlay, $) {
		'use strict';

		/**
    *  Dependency: <div class="overlay" data-overlay></div> in theme.liquid,
    *              components/_overlay.scss
    *
    *  Note: _overlay.scss hold the styles for the overlay container
    *  Note: .overlay has a z-index of 1000, so any modal that needs to appear on top
    *        of the overlay need to have an z-index of 1001+
    *
    *
    */

		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.overlay = $('[data-overlay]');
		};

		Overlay.show = function () {
			return $dom.overlay.fadeIn(300);
		};

		Overlay.hide = function () {
			return $dom.overlay.fadeOut(300);
		};

		Overlay.toggle = function () {
			return $dom.overlay.fadeToggle(300);
		};

		var bindUIActions = function bindUIActions() {
			$dom.overlay.on('click', window.Overlay.hide);
		};

		Overlay.init = function () {
			cacheDom();
			bindUIActions();
		};
	})(window.Overlay = window.Overlay || {}, _jquery2.default);
};